import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Titre from '../UI/Titre.jsx'
import FranceInterRemerciement from '../UI/FranceInter/FranceInterRemerciement.jsx';
import Consent from '../UI/Consent.jsx';
import DonneesPersonnelles from '../UI/DonneesPersonnelles.jsx';
import { useCallback, useState } from 'react';
import { ManageCompteur } from '../Services/ManageCompteur.jsx';
import Accueil from '../UI/Accueil.jsx';
import FranceInterFooter from '../UI/FranceInter/FranceInterFooter.jsx';
import BtnRetour from '../UI/BtnRetour.jsx';
import Temoinage from '../UI/Temoinage.jsx';
import ImageBackground from '../UI/ImageBackground.jsx';
import Description from '../UI/Description.jsx';
import TextParticipation from '../UI/TextParticipation.jsx';

function TEX113100({
    interaction,
    afficherAccueil,
    afficherEtapeCollecteParticipation,
    afficherEtapeRemerciement,
    afficherEtapeGRPD,
    afficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeCollecteParticipation,
    changerEtapeRemerciement,
    changerEtapeCollecteParticipationVocale,

    setContinueEnabled,
    continueEnabled,

    audioBlob,
    setAudioBlob,
    audioURL,
    setAudioURL,
    sendRecordParticipation,
    sendingParticipationState,

    donneesPersonnelleValid,
    setField,
    userInformation,
    handleRememberMeChange,
    rememberMe,
    canDonneesPersonnelleContinue,
    saveDonneePersonnelle,

    setConsent,
    consentGDPR,
    consentImage,
    passerEtapeRGPDEnabled,
    setMessageErreur,
    retourAccueil,

    changerEtapeCollecteParticipationTexte,
    participation,
}) {

    const {
        counter,
        startCountdownTimer,
        stopCountdownTimer,
        afficherCompteur,
        setAfficherCompteur,
    } = ManageCompteur(interaction);

    const handleStartRecording = useCallback(
        (status) => {
            if (status === 'start') {
                startCountdownTimer();
            }
            if (status === 'stop') {
                stopCountdownTimer();
                setAfficherCompteur(true);
            }
        },
        [setAfficherCompteur, startCountdownTimer, stopCountdownTimer]
    );

    const [afficherEtapeCollecteParticipationImage, setAfficherEtapeCollecteParticipationImage] = useState(true);

    const handleAfficherCompteur = useCallback(
        () => {
            setAfficherCompteur(true);
        }, [setAfficherCompteur]
    );

    const textBTNRetour = "Précédent";

    return (
        <>
            <div class="questionnaire">
                <div className='template-france-inter'>
                    <Titre interaction={interaction} />

                    {afficherAccueil &&
                        // Page d accueil
                        <>
                            <Accueil
                                interaction={interaction}
                                changerPage={changerAfficherEtapeCollecteParticipation}
                                isImageBlur={false}
                                textBTNParticiper={'Envoyer un message écrit'}
                            />
                        </>
                    }
                    {afficherEtapeCollecteParticipation &&
                        // Page de collecte de participation (limité à 1 vote ou non)
                        <>

                            <Row className="custom-instructions align-left">
                                <Col>
                                    <Description interaction={interaction} />
                                </Col>
                            </Row>

                            <Row className="text-center">
                                <Col>
                                    <TextParticipation
                                        participation={participation}
                                        sendingParticipationState={sendingParticipationState}
                                        changerEtapeCollecteParticipationTexte={changerEtapeCollecteParticipationTexte}
                                    />
                                </Col>
                            </Row>
                        </>
                    }
                    {afficherEtapeCollectInformationsPersonnelles &&
                        <>
                            <DonneesPersonnelles
                                interaction={interaction}
                                setField={setField}
                                userInformation={userInformation}
                                donneesPersonnelleValid={donneesPersonnelleValid}
                                handleRememberMeChange={handleRememberMeChange}
                                rememberMe={rememberMe}
                                canDonneesPersonnelleContinue={canDonneesPersonnelleContinue}
                                saveDonneePersonnelle={saveDonneePersonnelle}
                            />
                            <BtnRetour
                                retourAccueil={retourAccueil}
                                textBTNRetour={textBTNRetour}
                            />
                        </>
                        // Page de collecte de données personnelles
                    }
                    {afficherEtapeGRPD &&
                        <>
                            <Consent
                                customisation={interaction.segment_customisation}
                                consentGDPR={consentGDPR}
                                consentImage={consentImage}
                                setConsent={setConsent}
                            />

                            <div class='d-flex justify-content-evenly fi-rgpd-btn'>
                                <BtnRetour
                                    retourAccueil={retourAccueil}
                                    textBTNRetour={textBTNRetour}
                                />
                                <Row className="custom-commandes">
                                    <Col>
                                        <Button onClick={changerEtapeRemerciement} disabled={!passerEtapeRGPDEnabled} className='continue'>Continuer</Button>
                                    </Col>
                                </Row>

                            </div>
                        </>
                        // Page de consentement
                    }
                    {afficherEtapeRemerciement &&
                        <>
                            <Row className="custom-commandes">
                                <Col>
                                    <FranceInterRemerciement interaction={interaction} >Continuer</FranceInterRemerciement>
                                </Col>
                            </Row>

                        </>
                        // Page de remerciemeent
                    }
                </div>

                <FranceInterFooter />
            </div>
        </>
    )
}
export default TEX113100;
